

















































































import { Component, Vue } from "vue-property-decorator";
import ReloadModule from "./store/modules/reload.module";
import store from "./store/index";
import { getModule } from "vuex-module-decorators";
const reloadModule = getModule(ReloadModule, store);
@Component({
  components: {},
})
export default class Layout extends Vue {
  public nd = true;
  public overlay = false;
  public selectedItem = null;
  public elencoView = [
    {
      text: "Tondi Trafilati",
      icon: "Tondi.jpg",
      link: "/tondi",
      name: "Tondi",
    },
    {
      text: "Quadri Trafilati",
      icon: "Quadri.jpg",
      link: "/quadri",
    },
    {
      text: "Piatti Trafilati",
      icon: "Piatti.jpg",
      link: "/piatti",
    },
    {
      text: "Esagoni Trafilati",
      icon: "Esagoni.jpg",
      link: "/esagoni",
    },
    {
      text: "Profili Speciali",
      icon: "Speciali.jpg",
      link: "/speciali",
    },
  ];

  goTo(element): void {
    if (this.$route.fullPath === element.link) {
      reloadModule.showReload();
    //   this.$router.replace({ name: "Tondi", params: { date: new Date().toString() } });
    } else {
      this.$router.push({ path: element.link });
    }
  }
}
